module.exports = __webpack_public_path__ + "img/6.153a79c1.png";